<template lang="html">
  <div class="container">
    <div class="row">
      <div class="col-md-4">
        <ext-table
          :fields="{
            name: { label: 'Роль' }
          }"
          :deleteProxy = "{ url: 'api/role/' + selectedRoleId, method: 'delete' }"
          :loadProxy = "{ url: 'api/role', method: 'get' }"
          @select = "(id) => { selectedRoleId = id }"
          :per-page="5"
        >

        <template slot="createForm">
          <ext-form :formData="roleFormData" :submitProxy="createRoleProxy" submitBtnText="Создать">
            <b-form-fieldset
              label="Роль"
              :feedback = "errors.first('name')"
              :class="{'is-invalid': errors.has('name') }"
            >
              <input class="form-control" v-validate="'required|eng'" v-model.trim="roleFormData.name"  name="name"/>
            </b-form-fieldset>
          </ext-form>
        </template>
        <template slot="updateForm">
          <ext-form
            :formData="roleFormData"
            :submitProxy = "{ url: 'api/role/' + selectedRoleId, method: 'post' }"
            :loadProxy = "{ url: 'api/role/' + selectedRoleId, method: 'get' }"
            submitBtnText="Обновить">
            <b-form-fieldset
              label="Роль"
              :feedback = "errors.first('name')"
              :class="{'is-invalid': errors.has('name') }"
            >
              <input class="form-control" v-validate="'required|eng'" v-model.trim="roleFormData.name"  name="name"/>
            </b-form-fieldset>
          </ext-form>
        </template>

        </ext-table>
      </div>
      <div class="col-md-8">
        <ext-table
          :filter = "{ role_id: selectedRoleId }"
          :fields="{
            entity:  { label: 'Сущность' },
            create:  { label: 'Создание', formatter: formatBool },
            read:  { label: 'Чтение', formatter: formatBool },
            update:  { label: 'Обновление', formatter: formatBool },
            delete:  { label: 'Удаление', formatter: formatBool },
            owner:  { label: 'Изменение владельцем', formatter: formatBool }
          }"
          :loadProxy = "{ url: 'api/right', method: 'get' }"
          :deleteProxy = "{ url: 'api/right/' + selectedRightId, method: 'delete' }"
          :per-page="5"
          :disableCreateBtn = "!selectedRoleId"
          @select = "(id) =>  selectedRightId = id "
        >


        <template slot="createForm">
          <right-form
            :submitProxy = "{ url: 'api/right', method: 'put' }"
            :extraData = "{ role_id: selectedRoleId}"
          />
        </template>
        <template slot="updateForm">
          <right-form
            :submitProxy = "{ url: 'api/right/' + selectedRightId, method: 'post' }"
            :loadProxy = "{ url: 'api/right/' + selectedRightId, method: 'get' }"
            :extraData = "{ role_id: selectedRoleId}"
          />
        </template>
          <right-form/>
        </ext-table>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-md-12">
        <ext-table

          :fields="{
            name: { label: 'Имя' },
            login: { label: 'Логин' },
            role: { label: 'Роль', formatter: function (role) { return role.name } }
          }"
          :deleteProxy = "{ url: 'api/user/' + selectedUserId, method: 'delete' }"
          :loadProxy = "{ url: 'api/user', method: 'get' }"
          @select = "(id) => { selectedUserId = id }"
          :per-page="5"
        >

          <template slot="createForm">
            <full-account-form
              :submitProxy = "{ url: 'api/user', method: 'put' }"
            />
          </template>
          <template slot="updateForm">
            <full-account-form
              :submitProxy = "{ url: 'api/user/' + selectedUserId, method: 'post' }"
              :loadProxy = "{ url: 'api/user/' + selectedUserId, method: 'get' }"
            />
          </template>
        </ext-table>

      </div>
    </div>
  </div>
</template>

<script>
import ExtTable from '@/components/ExtTable'
import ExtForm from '@/components/ExtForm'
import RightForm from '@/forms/RightForm'
import FullAccountForm from '@/forms/FullAccountForm'

export default {
  data () {
    return {
      selectedRoleId: '',
      selectedRightId: '',
      selectedUserId: '',
      createRoleProxy: {
        url: 'api/role',
        method: 'put'
      },
      roleFormData: {
        name: ''
      }
    }
  },
  methods: {
    formatBool (v) {
      return v === 1 ? 'да' : 'нет'
    }
  },
  components: {
    ExtTable,
    ExtForm,
    RightForm,
    FullAccountForm
  }
}
</script>



// WEBPACK FOOTER //
// RightsManage.vue?0cac8000